import { useEffect, useState } from 'react';

const useUserLocation = () => {
	const [userLocation, setUserLocation] = useState('');
	const [data, setData] = useState('');

	useEffect(() => {
		const countryCode = sessionStorage.getItem('country_code');
		if (!countryCode) {
			dbip.getVisitor({}).then(showVisitorInfo);
		} else {
			setUserLocation(countryCode);
		}

		function showVisitorInfo(info) {
			setUserLocation(info.countryCode);
			sessionStorage.setItem('country_code', info.countryCode);
		}
	}, []);

	useEffect(() => {
		if (userLocation.length > 0) {
			const fetchData = async () => {
				const response = await fetch(ajax_params.ajaxurl, {
					method: 'POST',
					credentials: 'same-origin',
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded',
						'Cache-Control': 'no-cache',
					},
					body: new URLSearchParams({
						action: 'get_user_location_info',
						userLocation: userLocation,
						nonce: ajax_params.nonce,
					}),
				});
				setData(await response.json());
			};
			fetchData();
		}
	}, [userLocation]);

	return data;
};

export default useUserLocation;
